import { useLayoutEffect, useRef } from 'react'
import styles from './ImpersonationBanner.module.css'
import { getImpersonatedUser, getImpersonationReturnTo, setImpersonatedUser } from '@/lib/impersonation'

export function ImpersonationBanner() {
  const user = getImpersonatedUser()
  const ref = useRef<HTMLDivElement>(null)

  // Publish the banner's height as a CSS var on the document root so that
  // fixed/sticky elements (e.g. PageLayout's header) can offset their `top`
  // and avoid being covered by the banner.
  useLayoutEffect(() => {
    if (!user) return
    const el = ref.current
    if (!el) return
    const update = () => {
      document.documentElement.style.setProperty('--impersonation-banner-h', `${el.offsetHeight}px`)
    }
    update()
    const observer = new ResizeObserver(update)
    observer.observe(el)
    return () => {
      observer.disconnect()
      document.documentElement.style.removeProperty('--impersonation-banner-h')
    }
  }, [user])

  if (!user) return null

  const handleStop = () => {
    setImpersonatedUser(null)
    window.location.assign(getImpersonationReturnTo(user))
  }

  return (
    <div ref={ref} className={styles.banner}>
      <span className={styles.text}>
        Viewing as <span className={styles.name}>{user.name || user.email}</span>
        {user.name && ` (${user.email})`}
      </span>
      <button className={styles.stopButton} onClick={handleStop}>
        Stop Impersonating
      </button>
    </div>
  )
}
